import { Box, InputBase, Typography } from '@mui/material'
import React, { useState } from 'react'
import ModalHeader from '../../common/Header'
import DropDown from '../../common/DropDown'
import MButton from '../../common/MButton'
import { useDispatch, useSelector } from 'react-redux'
import { updateShowAlert } from '../../../redux/Actions'
import TextBox from '../../common/TextBox'
import { sendGroupBoardingSms } from '../../../redux/Report/ReportActions'

const SMSDetails = (props) => {
    const { filterOpt, filterValue, setFilterValue, handleBack } = props
    const { userDetails } = useSelector((state) => state.common);
    const dispatch = useDispatch()
    const [smsdetail, setSmsDetails] = useState({
        staffNo: '',
        contactNo: '',
        delayedByHrs: '',
        delayedByMin: '',
        busNo: '',
        pickupPoint: '',
        vehicleType: '',
        vehicleNo: '',
        preBusType: '',
        newBusType: '',
        customeSMS: '',
    })
    const createSMSBody = (type, details, bookingIDs) => {
        return {
            intCompanyID: userDetails?.CompanyID ?? 0,
            companyName: userDetails?.CompanyName ?? '',
            bookingIDs: bookingIDs ?? [],
            smsType: filterValue?.smsType?.[0]?.SMSTypeID ?? null,
            param1: details.param1 ?? '',
            param2: details.param2 ?? '',
            param3: details.param3 ?? '',
            param4: details.param4 ?? '',
            param5: details.param5 ?? '',
            param6: details.param6 ?? '',
            strStaffMobile: details.staffNo ?? ''
        };
    };
    const handleSendClick = () => {
        const isValidMobileNumber = (number) => /^[6-9]\d{9}$/.test(number);
        const requiredFieldsMap = {
            BusDelay: ["staffNo", "contactNo", "delayedByHrs", "delayedByMin"],
            BusCancelled: ["staffNo", "contactNo"],
            BusNoChanged: ["staffNo", "busNo", "contactNo", "delayedByHrs", "delayedByMin"],
            PickupChanged: ["staffNo", "pickupPoint", "contactNo", "delayedByHrs", "delayedByMin"],
            PickupVanDetails: ["staffNo", "vehicleType", "vehicleNo", "contactNo"],
            BusTypeChange: ["staffNo", "busNo", "contactNo", "delayedByHrs", "delayedByMin", "preBusType", "newBusType"],
            customSMS: ["staffNo"],
            BusEarly: ["staffNo", "contactNo", "delayedByHrs", "delayedByMin"]
        };
        const selectedSMSType = filterValue?.smsType?.[0]?.SMSTypeID ?? "";
        const requiredFields = requiredFieldsMap[selectedSMSType] || [];
        // Check for missing fields
        const missingField = requiredFields.find(field =>
            smsdetail[field] === undefined || smsdetail[field] === null ||
            (typeof smsdetail[field] === "string" && smsdetail[field].trim() === "")
        );
        if (missingField) {
            dispatch(updateShowAlert({
                msg: `Please Enter ${missingField.replace(/([A-Z])/g, ' $1').trim()}!`,
                open: true,
            }));
            return;
        }
        // Validate staffNo and contactNo
        if (requiredFields.includes("staffNo") && !isValidMobileNumber(smsdetail.staffNo)) {
            dispatch(updateShowAlert({
                msg: "Please enter a valid 10-digit Staff No!",
                open: true,
            }));
            return;
        }
        if (requiredFields.includes("contactNo") && !isValidMobileNumber(smsdetail.contactNo)) {
            dispatch(updateShowAlert({
                msg: "Please enter a valid 10-digit Contact No!",
                open: true,
            }));
            return;
        }
        const bookingIDs = filterValue?.selectedItemsForSMS.length > 1 ? filterValue.selectedItemsForSMS.join(",") : filterValue.selectedItemsForSMS[0] || 0;
        const smsDetailsMap = {
            BusDelay: { param1: smsdetail?.delayedByHrs, param2: smsdetail?.delayedByMin, param3: smsdetail?.contactNo },
            BusCancelled: { param1: smsdetail?.contactNo },
            BusNoChanged: { param1: smsdetail?.busNo, param2: smsdetail?.contactNo, param3: smsdetail?.delayedByHrs, param4: smsdetail?.delayedByMin },
            PickupChanged: { param1: smsdetail?.pickupPoint, param2: smsdetail?.contactNo, param3: smsdetail?.delayedByHrs, param4: smsdetail?.delayedByMin },
            BusTypeChange: { param1: smsdetail?.busNo, param2: smsdetail?.contactNo, param3: smsdetail?.delayedByHrs, param4: smsdetail?.delayedByMin, param5: smsdetail?.preBusType, param6: smsdetail?.newBusType },
            PickupVanDetails: { param1: smsdetail?.vehicleType, param2: smsdetail?.vehicleNo, param3: smsdetail?.contactNo },
            customSMS: { param1: smsdetail?.customeSMS },
            BusEarly: { param1: smsdetail?.delayedByHrs, param2: smsdetail?.delayedByMin, param3: smsdetail?.contactNo }
        };
        const body = createSMSBody(selectedSMSType, smsDetailsMap[selectedSMSType] || {}, bookingIDs);
        dispatch(sendGroupBoardingSms(body)).then((res) => {
            if (res.data.MavenAPIGroupBoardingReportDataResult.IsSuccess) {
                dispatch(updateShowAlert({
                    msg: "SMS sent successfully!",
                    open: true,
                }));
            } else {
                dispatch(updateShowAlert({
                    msg: res?.data?.MavenAPIGroupBoardingReportDataResult.ErrorMessage,
                    open: true,
                }));
            }

        })
        // setCurrentScreen(5)
    };
    return (
        <Box>
            <ModalHeader headerText={"SMS Details"} showBackArrow={true} onBackClick={handleBack} />
            <Box className='filter-section-pickups'>
                <Box className='filterRow'>
                    <Box className='filterLabel'>
                        <Typography>Staff MNo.</Typography>
                    </Box>
                    <Box className='dropDownFilter'>
                        <TextBox type="number" maxLength={10} value={smsdetail?.staffNo} onChange={(e) => setSmsDetails((prev) => ({ ...prev, staffNo: e.target.value }))} />
                    </Box>
                </Box>
                <Box className='filterRow'>
                    <Box className='filterLabel'>
                        <Typography>SMS Type</Typography>
                    </Box>
                    <Box className='dropDownFilter'>
                        <DropDown
                            label='SMS Type'
                            showTopLable={false}
                            headerLabel='Select SMS Type'
                            StartIcon={true}
                            option={filterOpt?.smsTypeList || []}
                            primaryKey='SMSTypeID'
                            labelKey='SMSType'
                            preSelectedValues={filterValue?.smsType || []}
                            onSelect={(val) => {
                                setFilterValue((prev) => ({
                                    ...prev,
                                    smsType: val
                                }));
                            }}
                        />
                    </Box>
                </Box>
                {['BusNoChanged', 'BusTypeChange'].includes(filterValue?.smsType[0]?.SMSTypeID) && (
                    <Box className='filterRow'>
                        <Box className='filterLabel'>
                            <Typography>Bus No.</Typography>
                        </Box>
                        <Box className='dropDownFilter'>
                            <TextBox type="number" label="Bus NO" value={smsdetail?.busNo} onChange={(e) => setSmsDetails((prev) => ({ ...prev, busNo: e.target.value }))} />
                        </Box>
                    </Box>
                )}
                {filterValue?.smsType[0]?.SMSTypeID === 'PickupChanged' && (
                    <Box className='filterRow'>
                        <Box className='filterLabel'>
                            <Typography>Pickup Point</Typography>
                        </Box>
                        <Box className='dropDownFilter'>
                            <TextBox type="text" label="Pickup Point" value={smsdetail?.pickupPoint} onChange={(e) => setSmsDetails((prev) => ({ ...prev, pickupPoint: e.target.value }))} />
                        </Box>
                    </Box>
                )}
                {filterValue?.smsType[0]?.SMSTypeID === 'PickupVanDetails' && (
                    <>
                        <Box className='filterRow'>
                            <Box className='filterLabel'>
                                <Typography>Vehicle Type</Typography>
                            </Box>
                            <Box className='dropDownFilter'>
                                <TextBox type="text" label="Vehicle Type" value={smsdetail?.vehicleType} onChange={(e) => setSmsDetails((prev) => ({ ...prev, vehicleType: e.target.value }))} />
                            </Box>
                        </Box>
                        <Box className='filterRow'>
                            <Box className='filterLabel'>
                                <Typography>Vehicle No.</Typography>
                            </Box>
                            <Box className='dropDownFilter'>
                                <TextBox type="text" label="Vehicle No" value={smsdetail?.vehicleNo} onChange={(e) => setSmsDetails((prev) => ({ ...prev, vehicleNo: e.target.value }))} />
                            </Box>
                        </Box>
                    </>
                )}
                {['BusDelay', 'BusCancelled', 'BusNoChanged', 'PickupChanged', 'PickupVanDetails', 'BusTypeChange', 'BusEarly'].includes(filterValue?.smsType[0]?.SMSTypeID) && (
                    <Box className='filterRow'>
                        <Box className='filterLabel'>
                            <Typography>Contact No.</Typography>
                        </Box>
                        <Box className='dropDownFilter'>
                            <TextBox type="number" maxLength={10} value={smsdetail?.contactNo} onChange={(e) => setSmsDetails((prev) => ({ ...prev, contactNo: e.target.value }))} />
                        </Box>
                    </Box>
                )}
                {['BusDelay', 'BusNoChanged', 'PickupChanged', 'BusTypeChange', 'BusEarly'].includes(filterValue?.smsType[0]?.SMSTypeID) && (
                    <Box className='filterRow'>
                        <Box className='filterLabel'>
                            <Typography>Delayed By</Typography>
                        </Box>
                        <Box className='dropDownFilter' sx={{ display: 'flex', gap: '2px' }}>
                            <TextBox type="number" maxLength={2} value={smsdetail?.delayedByHrs} onChange={(e) => setSmsDetails((prev) => ({ ...prev, delayedByHrs: e.target.value }))} />
                            <TextBox type="number" maxLength={2} value={smsdetail?.delayedByMin} onChange={(e) => setSmsDetails((prev) => ({ ...prev, delayedByMin: e.target.value }))} />
                        </Box>
                    </Box>
                )}
                {filterValue?.smsType[0]?.SMSTypeID === 'BusTypeChange' && (
                    <>
                        <Box className='filterRow'>
                            <Box className='filterLabel'>
                                <Typography>Pre Bus Type</Typography>
                            </Box>
                            <Box className='dropDownFilter'>
                                <TextBox type="text" label="Pre Bus Type" value={smsdetail?.preBusType} onChange={(e) => setSmsDetails((prev) => ({ ...prev, preBusType: e.target.value }))} />
                            </Box>
                        </Box>
                        <Box className='filterRow'>
                            <Box className='filterLabel'>
                                <Typography>New Bus Type</Typography>
                            </Box>
                            <Box className='dropDownFilter'>
                                <TextBox type="text" label="New Bus Type" value={smsdetail?.newBusType} onChange={(e) => setSmsDetails((prev) => ({ ...prev, newBusType: e.target.value }))} />
                            </Box>
                        </Box>
                    </>
                )}
                <Box className='smsTemplateLable'>SMS Template</Box>
                <Box className='smsTemplateBox'>
                    {filterValue?.smsType[0]?.SMSTypeID === 'customSMS' ? (
                        <InputBase
                            fullWidth
                            multiline
                            placeholder="Enter your custom message"
                            value={smsdetail.customSMS}
                            rows={4}
                            onChange={(e) =>
                                setSmsDetails((prev) => ({ ...prev, customeSMS: e.target.value }))
                            }
                            sx={{
                                border: 'none',
                                outline: 'none',
                                fontSize: 'inherit',
                                width: '100%',
                                background: 'transparent',
                            }}
                        />
                    ) : (
                        filterValue?.smsType?.[0]?.Template
                    )}
                </Box>
            </Box>
            <Box className="bookingTypeBottom">
                <MButton btnName="Send" className="btnContinue" onClick={handleSendClick} />
            </Box>
        </Box>
    )
}

export default SMSDetails